window.loadJSscripts();
(function () {
    var root = document.getElementById('rewards-yotpo-hero-root');
    if (!root) return;

    function promoteTitleToH1() {
      var section = root.querySelector('.yotpo-widget-hero-section');
      if (!section) return false;
      var el = section.querySelector('.yotpo-title');
      if (!el || el.tagName === 'H1') return !!el;

      var h1 = document.createElement('h1');
      for (var i = 0; i < el.attributes.length; i++) {
        var a = el.attributes[i];
        h1.setAttribute(a.name, a.value);
      }
      while (el.firstChild) h1.appendChild(el.firstChild);
      el.parentNode.replaceChild(h1, el);
      return true;
    }

    if (promoteTitleToH1()) return;

    var obs = new MutationObserver(function () {
      if (promoteTitleToH1()) obs.disconnect();
    });
    obs.observe(root, { childList: true, subtree: true });
  })();

  (function () {
    var earningPoints = document.querySelector('[data-yopto-earning-points]');
    if (!earningPoints) return;

    function isMobile() {
      return window.innerWidth <= 767;
    }

    function resetListItems(target) {
      target.querySelectorAll('[role="listitem"]').forEach(function (item) {
        item.classList.remove('has-overflow');
        var style = item.getAttribute('style') || '';
        style = style.replace(/;\s*--scrollheight:\s*[^;]+/g, '').replace(/^--scrollheight:\s*[^;]+;?\s*/g, '').trim();
        if (style) {
          item.setAttribute('style', style);
        } else {
          item.removeAttribute('style');
        }
      });
    }

    function checkListItemOverflow(target) {
      requestAnimationFrame(function () {
        if (!isMobile()) {
          resetListItems(target);
          return;
        }
        var listItems = target.querySelectorAll('[role="listitem"]');
        listItems.forEach(function (item) {
          var tile = item.querySelector('.yotpo-tile-wrapper');
          if (!tile) return;
          var visibleHeight = tile.getBoundingClientRect().height;
          var fullHeight = tile.scrollHeight - 15;
          if (fullHeight > Math.ceil(visibleHeight)) {
            item.classList.add('has-overflow');
            var existing = item.getAttribute('style') || '';
            var cleaned = existing.replace(/;\s*$/, '').trim();
            item.setAttribute('style', (cleaned ? cleaned + '; ' : '') + '--scrollheight: ' + fullHeight + 'px');
          }
        });
      });
    }

    function onEarningPointsRendered(target) {
      if (!isMobile()) return;
      setTimeout(function () {
        checkListItemOverflow(target);
      }, 1000);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          checkListItemOverflow(target);
        }, 200);
      });
    }

    function isFullyRendered(target) {
      return target.querySelector('[role="listitem"] .yotpo-tile-wrapper') !== null;
    }

    if (isFullyRendered(earningPoints)) {
      onEarningPointsRendered(earningPoints);
      return;
    }

    var obs = new MutationObserver(function (mutations, observer) {
      if (isFullyRendered(earningPoints)) {
        observer.disconnect();
        onEarningPointsRendered(earningPoints);
      }
    });
    obs.observe(earningPoints, { childList: true, subtree: true });
  })();